import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledColorBadge = styled.div<{ color: string }>`
    background-color: ${({ color }) => color};
    border: 1px solid ${colorsPalettes.carbon["50"]};
    border-radius: 50%;
    bottom: -4px;
    height: 10px;
    position: absolute;
    right: -3px;
    width: 10px;
`;
